import { CSSObject } from '@chakra-ui/react';
import bg from '@/assets/titanbet/images/account/topNavBg.png';

export const TopNavContainer: CSSObject = {
  mt: '0',
  px: '0',
  pt: ['0', '1.5', '0'],
  pb: '0',
  overflowX: ['scroll', null, 'auto'],
  '::-webkit-scrollbar': {
    width: '0px',
    bg: 'transparent',
    height: '0',
  },
};

export const TopNavWrapper: CSSObject = {
  overflowX: ['scroll', null, 'visible'],
  flexDir: ['row', null, 'column'],
  minW: '160px',
  bg: ['blackAlpha.500', null, null, 'beta.600'],
  border: ['unset', null, null, '2px solid'],
  borderColor: ['unset', null, null, 'gamma.500'],
  boxShadow: [
    'unset',
    null,
    null,
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 3px #1B1E1F inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.07) inset',
  ],
  borderRadius: 'md',
  mb: '2',
  '&::-webkit-scrollbar': { display: 'none' },
  bgImage: ['unset', null, null, `url(${bg})`],
};

export const NavLinkLabel: CSSObject = {
  color: 'gamma.300',
  fontFamily: 'accent',
  textTransform: 'uppercase',
  fontWeight: 'normal',
  fontSize: 'sm',
  px: '3',
  py: '2',
  borderRadius: 'full',
};

export const NavLink = (isActive: boolean): CSSObject => ({
  bg: isActive ? ['transparent', null, null, 'beta.600'] : 'transparent',
  color: isActive
    ? ['gamma.300', null, 'alpha.200']
    : ['alpha.300', null, 'gamma.300'],
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
  textTransform: 'capitalize',
  fontWeight: 'normal',
  fontSize: 'xs',
  lineHeight: 'normal',
  pb: ['2', '3'],
  pt: ['3', '3'],
  pl: isActive ? ['2', '3'] : ['2', '4'],
  pr: ['2', '4'],
  mx: '3px',
  fontFamily: 'accent',
  borderLeft: ['unset', null, isActive && '3px solid'],
  borderLeftColor: ['unset', null, isActive && 'beta.600'],
  borderBottom: [isActive && '2px solid', null, '1px dashed'],
  borderBottomColor: [
    isActive && 'gamma.300',
    null,
    isActive ? 'beta.600' : 'blackAlpha.400',
  ],
  _first: {
    borderTopRadius: ['none', null, 'md'],
  },
  _last: {
    borderBottomRadius: 'md',
    borderBottom: 'none',
  },
  '&:hover, &:focus': {
    bg: !isActive && 'beta.600',
  },
});
